import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedsApi} from '../../../contentFeeds.api';
import {ContentFeedColumnsSchema} from '../../../contentFeeds.types';
import {setFeed} from '../reducers/contentFeedPageBase.slice';

export const updateFeedColumnsSchema = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/updateFeedColumnsSchema`,
  async ({feedId, schema}: {feedId: number; schema: ContentFeedColumnsSchema}, {dispatch}) => {
    await contentFeedsApi.updateFeedColumnsSchema(feedId, schema);
    const feed = await contentFeedsApi.getFeed(feedId);
    dispatch(setFeed(feed));
  },
);
